import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './shared/store/store';
import { Setting } from './shared/utils/Settings';
import Endpoint from './services/server-istances/Endpoints';
import SSOService from './services/controllers/login-services/SSOService';


if (Setting.OFFLINE_MODE){
    ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider> ,document.getElementById('root')
    )
}
else{
    initApplication();
}

async function initApplication() {
  const endpointService = Endpoint.getInstance();
  const env = await endpointService.getEnvironment();
  if (!env || !env.KEYCLOACK_CONFIG) throw new Error("Keycloak config missing");
  if (!env || !env.BACKEND_URL) throw new Error("Auth config missing");
  endpointService.setKEYCLOACK(env.KEYCLOACK_CONFIG);
  const ssoService = SSOService.getInstance();
  const renderApp = () =>  ReactDOM.render(
      <Provider store={store}>
          <App/>
      </Provider> ,document.getElementById('root')
  );
  const token = ssoService.getAccessToken();
  if (token && !ssoService.isAccessTokenExpired()) {
    renderApp();
    return;
  }
  if (ssoService.getRefreshToken()) {
    try {
      const refreshToken = SSOService.getInstance().getRefreshToken()
      if (!refreshToken) throw new Error("No refresh token available");
      const response = await fetch(
        env.BACKEND_URL + "api/v1/auth/refresh-token",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ refreshToken: refreshToken }),
        }
      );
  
      if (!response.ok) throw new Error("Refresh token failed");
  
      const data = await response.json();
      const ssoService = SSOService.getInstance();
      if(data.access_token)
        ssoService.setAccessToken(data.access_token);
      if(data)
      ssoService.setRefreshToken(data.refresh_token);
      
      renderApp();
      return;
    } catch (err) {
      ssoService.setAccessToken("");
      ssoService.setRefreshToken("");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      ssoService.doLogin();
      return;
    }
  }

  const code = ssoService.getCodeFromUrl();
  const redirectUri = window.location.origin + window.location.pathname;

  if (!code) {
    ssoService.doLogin();
    return;
  }

  try {
    const response = await fetch(
      env.BACKEND_URL + "api/v1/auth/token",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code, redirectUri }),
      }
    );

    if (!response.ok) throw new Error("Errore nello scambio del token");

    const data = await response.json();
    ssoService.setAccessToken(data.access_token);
    ssoService.setRefreshToken(data.refresh_token);

    renderApp();
  } catch (err) {
    console.error("Errore nel login Keycloak:", err);
  }
}
	